import React from 'react';
import {graphql} from 'gatsby';
import {convert} from 'html-to-text';
import {StaticImage} from 'gatsby-plugin-image';
import {useTranslation} from 'gatsby-plugin-react-i18next';

import SEO from '../../../components/Seo';
import parse from '../../../services/parse';
import ourCaramelData from '../../../assets/data/specialtyCaramel.json';
import PageLayout from '../../../components/Pages/PageLayout/PageLayout';
import TextSection from '../../../components/Pages/TextSection/TextSection';
import type {PageHeadProps} from '../../../types/page';
import type {I18nTranslations} from '../../../types/i18next';


const SpecialtyCaramelsPage = () => {
  const {t} = useTranslation();

  return (
    <PageLayout title={t(ourCaramelData.specialtycaramels.name as any)}>
      <TextSection
        image={
          <StaticImage
            src="../../../assets/images/our-caramel/specialty-caramel/caramel-spoon.webp"
            alt={t(ourCaramelData.specialtycaramels.paragraph1.alt as any)}
          />
        }
        alignImage="right"
        title={t(ourCaramelData.specialtycaramels.paragraph1.name as any)}
      >
        {parse(t(ourCaramelData.specialtycaramels.paragraph1.text as any))}
      </TextSection>

      <TextSection
        image={
          <StaticImage
            src="../../../assets/images/our-caramel/specialty-caramel/caramel-pastes.webp"
            alt={t(ourCaramelData.specialtycaramels.paragraph2.alt as any)}
          />
        }
        alignImage="left"
        title={t(ourCaramelData.specialtycaramels.paragraph2.name as any)}
      >
        {parse(t(ourCaramelData.specialtycaramels.paragraph2.text as any))}
      </TextSection>

      <TextSection
        image={
          <StaticImage
            src="../../../assets/images/our-caramel/specialty-caramel/caramel-flakes.webp"
            alt={t(ourCaramelData.specialtycaramels.paragraph3.alt as any)}
          />
        }
        alignImage="right"
        title={t(ourCaramelData.specialtycaramels.paragraph3.name as any)}
      >
        {parse(t(ourCaramelData.specialtycaramels.paragraph3.text1 as any))}
      </TextSection>

      <TextSection>
        <center>
          {parse(t(ourCaramelData.specialtycaramels.paragraph3.text2 as any))}
        </center>
      </TextSection>
    </PageLayout>
  );
};


export default SpecialtyCaramelsPage;


export const Head = ({data}: PageHeadProps) => {
  const translations: I18nTranslations = JSON.parse(data.locales.edges[0].node.data);

  return (
    <SEO
      title={`${translations.specialty_caramels.name} | ${translations.sethness_roquette}`}
      description={convert(translations.specialty_caramels.metadata)}
    />
  );
};


export const query = graphql`
  query($language: String!, $defaultLang: String!) {
    locales: allLocale(filter: {language: {in: [$language, $defaultLang]}}) {
      ...I18nFragment
    }
  }
`;
